import React, { useState, useEffect } from "react";
import api from "../../utils/api.utils";
import { useNavigate, useParams } from "react-router-dom";
import { FooterAdmin, MsgSucess } from "../../components/index.js";
import { ButtonFinalizar } from "../../components/ButtonFinalizar";
import { NavbarAdmin } from "../../components/NavbarAdmin";

import loadingGif from "../../imgs/loading-state.gif";
import {
  Button,
  Modal,
  Toast,
  Form,
  InputGroup,
  FormLabel,
} from "react-bootstrap";

import "../css/AdminHome.css";

export const Manifestacao = ({ loading, setLoading, message, setMessage }) => {
  const { id } = useParams();

  const [show, setShow] = useState(false);
  const [finalizar, setFinalizar] = useState();
  const [showMessage, setShowMessage] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseFinalizar = () => setFinalizar(false);
  const handleShowFinalizar = () => setFinalizar(true);

  const handleCloseSendMessage = () => setShowMessage(false);

  console.log(showMessage);

  const [ouvidorias, setOuvidorias] = useState();

  const [parecer, setParecer] = useState();

  let status;

  const [messageUser, setMessageUser] = useState("");

  const [users, setUsers] = useState([]);

  let userId = localStorage.getItem("userId");

  useEffect(() => {
    const getUser = async () => {
      try {
        const data = await api.getUserLogged(userId);
        setUsers(data);
      } catch (error) {
        console.log(error, "Error to get ouvidoria");
      }
    };
    getUser();
  }, [userId]);
  let userName;
  users.forEach((user) => {
    userName = user.full_name;
  });

  useEffect(() => {
    const getOuvidoria = async () => {
      try {
        const data = await api.getOuvidoria(id);
        setOuvidorias(data);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } catch (error) {
        console.log(error, "Error to get ouvidoria");
      }
    };
    getOuvidoria();
  }, [loading, setLoading, id, userId]);

  useEffect(() => {
    setTimeout(() => {
      setMessage(null);
    }, 5000);
  }, [message, setMessage]);

  const handleAssumir = async (e) => {
    const userId = localStorage.getItem("userId");

    try {
      const newAudit = await api.addAuditOuvidoria(id, { userId });
      navigate(0);
      return newAudit;
    } catch (error) {
      console.log(error);
      setMessage(error);
    }
  };

  const handleFinalizar = async (e) => {
    e.preventDefault();
    const userId = localStorage.getItem("userId");

    const tipo = e.target.innerText;

    try {
      const newAudit = await api.endAuditOuvidoria(id, userId, tipo, {
        parecer,
      });
      if (newAudit) {
        navigate(0);
      }
    } catch (error) {
      console.log(error);
      setMessage(error);
    }
  };

  const handleSimClick = (e) => {
    if (e) {
      e.preventDefault();
      handleSendMessage("sim");
    }
  };
  const handleNaoClick = (e) => {
    e.preventDefault();
    handleSendMessage("nao");
  };

  const handleShowMessage = (e) => {
    e.preventDefault();
    setShowMessage(true);
  };
  const handleSendMessage = async (tipo) => {
    console.log(tipo);

    let changeEtapa;

    if (tipo === "sim") {
      changeEtapa = true;
    }
    if (tipo === "nao") {
      changeEtapa = false;
    }

    try {
      const newMe = await api.sendMessageOuvidoria(id, {
        messageUser,
        userId,
        userName,
        changeEtapa,
      });
      console.log(newMe);
      navigate(0);
    } catch (error) {
      console.log(error);
      setMessage(error);
    }
  };
  let pendencia = "";
  return (
    <div>
      <NavbarAdmin />
      {message && <MsgSucess>{message}</MsgSucess>}
      {!loading ? (
        ouvidorias?.map((ouvidoria, index) => {
          const now = new Date(); // Data de hoje
          const past = new Date(ouvidoria.createdAt); // Outra data no passado
          const diff = Math.abs(now.getTime() - past.getTime()); // Subtrai uma data pela outra
          const days = Math.ceil(diff / (1000 * 60 * 60 * 24)); // Divide o total pelo total de milisegundos correspondentes a 1 dia. (1000 milisegundos = 1 segundo).

          if (ouvidoria.status === "cadastrada") status = "warning";
          if (ouvidoria.status.slice(0, 10) === "finalizada")
            status = "secondary";
          if (ouvidoria.status === "em-andamento") status = "info";
          if (days >= 2 && ouvidoria.status.slice(0, 10) !== "finalizada") {
            status = "danger";
          }

          if (ouvidoria.tipo === "reclamacoes") ouvidoria.tipo = "reclamações";
          if (ouvidoria.tipo === "sugestoes") ouvidoria.tipo = "sugestões";

          let anoOuv = ouvidoria.createdAt.slice(0, 4);
          return (
            <div key={index} className="container mt-3">
              <div className="mx-3 mt-3">
                <h4 className="d-flex justify-content-between">
                  <div>
                    <i className="bi bi-megaphone-fill"></i> Visualização da
                    manifestação{" "}
                    <span className="btn btn-success">
                      <strong>
                        {anoOuv}OUV{ouvidoria.protocolo_id}
                      </strong>
                    </span>
                  </div>
                  <span className={`btn btn-${status} mx-3`}>
                    {ouvidoria.status.toUpperCase().replace("-", " ") +
                      pendencia}
                  </span>
                </h4>
              </div>
              <hr />

              <div className="d-flex w-100 justify-content-end  px-3">
                {ouvidoria.status.slice(0, 10) !== "finalizada" ? (
                  !ouvidoria.responsible_id ? (
                    <Button
                      className="mx-3"
                      variant="primary"
                      onClick={handleShow}
                    >
                      Assumir
                    </Button>
                  ) : (
                    <Button
                      className="mx-3"
                      variant="primary"
                      onClick={handleShowFinalizar}
                    >
                      Finalizar
                    </Button>
                  )
                ) : (
                  <></>
                )}
              </div>
              <div className="align-mobile d-flex flex-column ">
                <div className="card m-3">
                  <div className="d-flex card-header justify-content-between align-items-center">
                    <h5 className=" mb-0">Dados da manifestação</h5>
                  </div>
                  <div className="card-body">
                    <table className="table table-borderless table-striped">
                      <tbody>
                        <tr>
                          <td> Data da manifestação:</td>
                          <td>
                            <b>
                              {new Intl.DateTimeFormat("default", {
                                timeZone: "America/Sao_Paulo",
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              }).format(new Date(ouvidoria.createdAt))}
                              h
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td>Tipo:</td>
                          <td>
                            <b>
                              {ouvidoria.tipo[0].toUpperCase() +
                                ouvidoria.tipo.substring(1)}
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td>Manifestante:</td>
                          <td>
                            <b>{ouvidoria.name || <span>Anônimo</span>}</b>
                          </td>
                        </tr>
                        {ouvidoria.name && (
                          <>
                            <tr>
                              <td>E-mail:</td>
                              <td>
                                <b>{ouvidoria.email}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>Telefone:</td>
                              <td>
                                <b>{ouvidoria.telephone}</b>
                              </td>
                            </tr>
                          </>
                        )}
                        <tr>
                          <td>Etapa atual:</td>
                          <td>
                            <b>
                              {ouvidoria.etapa[0].toUpperCase() +
                                ouvidoria.etapa.substring(1)}
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td>Detalhes:</td>
                          <td>{ouvidoria.details}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {ouvidoria.status !== "cadastrada" ? (
                  <div className="card m-3">
                    <div className="d-flex card-header justify-content-between align-items-center">
                      <h5 className=" mb-0 w-100 text-center">Mensagens</h5>
                    </div>
                    <div className="card-body">
                      <Toast key={index} className=" mb-2 w-75">
                        <Toast.Header closeButton={false}>
                          <i className="bi bi-person-circle"> </i>
                          <strong className="me-auto mx-2">
                            {ouvidoria.name || <span>Anônimo</span>}
                          </strong>
                          <small>
                            {new Intl.DateTimeFormat("default", {
                              timeZone: "America/Sao_Paulo",
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            }).format(new Date(ouvidoria.createdAt))}
                            h
                          </small>
                        </Toast.Header>
                        <Toast.Body>{ouvidoria.details}</Toast.Body>
                      </Toast>
                      {ouvidoria?.messages_id.map((message, index) => {
                        let styleOuvi = "";
                        if (message.userId) {
                          styleOuvi = "styleOuvidoria";
                        }
                        return (
                          <Toast
                            key={index}
                            className={`${styleOuvi} mb-2 w-75`}
                          >
                            <Toast.Header closeButton={false}>
                              <i className="bi bi-person-circle"> </i>
                              <strong className="me-auto mx-2">
                                {" "}
                                {message.userName}
                                {message.userId ? " (ouvidoria)" : ""}
                              </strong>
                              <small>
                                {new Intl.DateTimeFormat("default", {
                                  timeZone: "America/Sao_Paulo",
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                }).format(new Date(message.createdAt))}
                                h
                              </small>
                            </Toast.Header>
                            <Toast.Body>{message.descricao}</Toast.Body>
                          </Toast>
                        );
                      })}
                      {ouvidoria.etapa === "ouvidoria" &&
                      !ouvidoria.resolucao ? (
                        <form
                          onSubmit={handleSendMessage}
                          className="w-100 d-flex mt-3"
                        >
                          <InputGroup className="mb-3 mt-3">
                            <Form.Control
                              as="textarea"
                              arial-label="Message"
                              value={messageUser}
                              onChange={(e) => setMessageUser(e.target.value)}
                            />
                            <button
                              className="btn btn-primary"
                              onClick={handleShowMessage}
                            >
                              <i className="bi bi-send-fill"></i>
                            </button>
                          </InputGroup>
                        </form>
                      ) : ouvidoria.status === "em-andamento" ? (
                        <>Aguardando resposta do reclamante.</>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {ouvidoria.resolucao ? (
                <div className="align-mobile auditoria d-flex">
                  <div className="card w-100 m-3">
                    <div className="d-flex card-header justify-content-between align-items-center">
                      <h5 className=" mb-0 w-100 text-center">Resolução</h5>
                    </div>
                    <div className="card-body">{ouvidoria.resolucao}</div>
                  </div>
                </div>
              ) : null}
              <div className="align-mobile auditoria d-flex">
                <div className="card w-100 m-3">
                  <div className="d-flex card-header justify-content-between align-items-center">
                    <h5 className=" mb-0 w-100 text-center">Auditoria</h5>
                  </div>
                  <div className="card-body">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>DATA</th>
                          <th className="no-mobile">OPERAÇÃO</th>
                          <th>DESCRIÇÃO</th>
                          <th>USUÁRIO</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ouvidoria.audits.map((audit, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {new Intl.DateTimeFormat("default", {
                                  timeZone: "America/Sao_Paulo",
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                }).format(new Date(audit.createdAt))}
                                h
                              </td>
                              <td className="no-mobile">{audit.operacao}</td>
                              <td>{audit.descricao}</td>
                              <td>{audit.userName}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Modal */}
              {/*MODAL ASSUMIR */}
              <Modal
                style={{ marginTop: "20%" }}
                show={show}
                onHide={handleClose}
              >
                <form onSubmit={handleAssumir}>
                  <Modal.Header closeButton>
                    <h6>Deseja assumir o controle desta manifestação?</h6>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="d-flex flex-column">
                      <span>
                        Protocolo n. <b> {ouvidoria.protocolo_id}</b>
                      </span>
                      <span>
                        Data da manifestação:{" "}
                        <b>
                          {new Date(
                            ouvidoria.createdAt.slice(0, -1)
                          ).toLocaleDateString("pt-br", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          })}
                        </b>
                      </span>
                      <span>
                        Manifestação de <b> {ouvidoria.tipo}</b>
                      </span>
                      <span>
                        Reclamante: <b> {ouvidoria.name || "Anônimo"}</b>
                      </span>
                      <span>
                        Etapa atual: <b> {ouvidoria.etapa}</b>
                      </span>
                    </p>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-primary" type="submit">
                      Sim
                    </button>
                    <Button variant="secondary" onClick={handleClose}>
                      Não
                    </Button>
                  </Modal.Footer>
                </form>
              </Modal>
              {/*MODAL FINALIZAR */}
              <Modal
                style={{ marginTop: "20%" }}
                show={finalizar}
                onHide={handleCloseFinalizar}
                aria-labelledby="example-modal-sizes-title-lg"
                size="lg"
              >
                <form>
                  <Modal.Header closeButton>
                    <h6>Deseja finalizar esta manifestação?</h6>
                  </Modal.Header>
                  <Modal.Body className="d-flex">
                    <p className="d-flex flex-column w-50">
                      <span>
                        Protocolo n. <b> {ouvidoria.protocolo_id}</b>
                      </span>
                      <span>
                        Data da manifestação:{" "}
                        <b>
                          {new Date(
                            ouvidoria.createdAt.slice(0, -1)
                          ).toLocaleDateString("pt-br", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                          })}
                        </b>
                      </span>
                      <span>
                        Manifestação de <b> {ouvidoria.tipo}</b>
                      </span>
                      <span>
                        Reclamante: <b> {ouvidoria.name || "Anônimo"}</b>
                      </span>
                      <span>
                        Etapa atual: <b> {ouvidoria.etapa}</b>
                      </span>
                    </p>
                    <div className="w-50 d-flex flex-column">
                      <FormLabel>Resolução:</FormLabel>
                      <textarea
                        value={parecer}
                        onChange={(e) => setParecer(e.target.value)}
                      ></textarea>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonFinalizar
                      tipo="Procedente"
                      handleFinalizar={handleFinalizar}
                    />
                    <ButtonFinalizar
                      tipo="Improcedente"
                      handleFinalizar={handleFinalizar}
                    />
                    <ButtonFinalizar
                      tipo="Dados Insuficientes"
                      handleFinalizar={handleFinalizar}
                    />
                    <Button variant="secondary" onClick={handleCloseFinalizar}>
                      Não Finalizar
                    </Button>
                  </Modal.Footer>
                </form>
              </Modal>
              {/*MODAL mensagem */}
              <Modal
                style={{ marginTop: "20%" }}
                show={showMessage}
                onHide={handleCloseSendMessage}
                // size="lg"
              >
                <form onSubmit={handleSendMessage}>
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="d-flex flex-column">
                    <h5>
                      Deseja manter a manifestação na sua etapa (ouvidoria)?
                    </h5>
                    <span>
                      Ex: Se ainda estiver analisando a situação e não puder
                      fornecer uma resposta definitiva de imediato, por favor,
                      responda "sim".
                    </span>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={(e) => handleSimClick(e)}
                    >
                      Sim
                    </Button>
                    <Button variant="primary" onClick={handleNaoClick}>
                      Não
                    </Button>
                  </Modal.Footer>
                </form>
              </Modal>
            </div>
          );
        })
      ) : (
        <div className="d-flex justify-content-center">
          <img style={{ width: "100px" }} src={loadingGif} alt="Loading gif" />
        </div>
      )}
      <hr className="espacamento-100" />
      <FooterAdmin />
    </div>
  );
};
